module.exports = __webpack_public_path__ + "img/logot.7b853abf.png";